module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAABHklEQVRIx2Ng9l30fzBjhlEHUurAs6fv7B7MmOGtrOr/wYxJcuA7LaP/n6IS/n8uLPv/0Tvw/1sFjcHjwM+5Rf//ffjw///fv/+/dfX9B4Hf5y/+/+DgNvAO/Bga/f//v38QRx0/+f+dvtn//3/+gPl/Hz76/05db2Ad+HPdxv8/N24B488pmWCxb5OnQ8Q2bf3/tb554Bz4TlX3//+vX/9/rWvGmiZ/bt76/+f2XQPswN+/wdH5fd5ChJyiBjh6QWBAHQjCv8+eBzvka0vH/7dyasCM4Q4RP30WIt7WNTgyycfA8P+/Dh+F5ORJ0/5/be0cHJkEhD9l5f//e//Bf2Twc9eewVHMoBfUX0oqB19BPWBV3aBvLIy2B4e7AwG0eS8bTXPM8wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/kp.png
// module id = 861
// module chunks = 0